export enum Right {
  authorisedUser = 'authorisedUser',
  manageScenes = 'manageScenes',
  manageAssets = 'manageAssets',
  manageWorkspaces = 'manageWorkspaces',
  manageUser = 'manageUser',
  admin = 'admin',
}